import API from "../services/apiservices";

async function getid() {
  await API.getLocalDBDocument("consumidoresStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].id;
    } else {
      return 0;
     }
  });
}


export default {
  namespaced: true,
  namespace: "consumidoresStore",

  state: {
    storename: "consumidoresStore",
    consumidores: {
      id: 0,
      api: null,
      data: [],
      error: null
    },
    emptyconsumidores: {
      id: 0,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "consumidoresStore", route: "Servicos/ConsumidoresClientes/Get", setter: "setConsumidores"}),
    gtxConsumidores: (state) => state.consumidores,
    gtxConsumidores_data: (state) => state.consumidores.data || [],
    gtxConsumidores_GetById: (state) => (id) => state.consumidores.data.find(f => f.idConsumidor == id) || {value: 0, text: ""},
    gtxConsumidores_selected: (state, getters) => state.consumidores.data.find(f => f.idConsumidor == getters.gtxConsumidores_idConsumidor),
    gtxConsumidores_dataoptions: (state) => (codigo_cliente) => state.consumidores.data ? state.consumidores.data.filter(f=>f.Codigo_Cliente == codigo_cliente).map(o=>({value: o.idConsumidor, text: o.Nome})).sort((a, b) => a.text.localeCompare(b.text)) : [],
    gtxConsumidores_idConsumidor: (state) => state.consumidores.idConsumidor,
    gtxConsumidores_Nome: (state, getters) => {
      const data = state.consumidores.data.find(f => f.idConsumidor == getters.gtxConsumidores_idConsumidor);
      return data ? data.Nome : "";
    },
    gtxConsumidores_error: (state) => state.consumidores.error,
  },

  mutations: {
    setConsumidores: (state, consumidores) => (state.consumidores = consumidores && consumidores.data && consumidores.data.length > 0 ? {idConsumidor: consumidores.data[0].idConsumidor, api: consumidores.apiresponse, data: consumidores.data, error: null} : state.emptyconsumidores),
    setConsumidoresidConsumidor: (state, idConsumidor) => (state.consumidores.idConsumidor = idConsumidor),
    setConsumidoresdata: (state, data) => (state.consumidores.data = data),
  },

  actions: {
    actConsumidoresGet({ commit, getters }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "consumidoresStore", route: "Servicos/marcas/Get", setter: "setConsumidores"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], idConsumidor: 0, error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
            });
          }).catch((error) => {
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc && doc.data) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                const emptyData = { data: [], idConsumidor: 0, error: error.message };
                res(emptyData);
              }
            });
          });
        } catch (err) {
          rej(err);
        }
      });
    },
  },
};
